import { Box, Typography } from "@mui/material";

export default function BlocNotesPrivacyEngPage() {
  return (
    <Box>
      <h1>Bloc Notes Privacy Policy</h1>

      <h3>What is the Privacy Policy and what does it cover?</h3>

      <p>
        We from <b>Podosoft</b>, do encourage you to read our Privacy Policy to
        help you use our Products in the way that’s right for you. <br />
        Our Privacy Policy ("Privacy Policy") helps explain our data practices,
        including the information we process to provide our Services.
        <br />
        Respect for your privacy is the number one thing we want to help you
        with even if we give you the full responsibility of that. Since we
        started Bloc, early in 2022, we’ve build the service with a set of
        privacy principles in mind. In the following content, you’ll find :{" "}
      </p>
      <ul>
        <li>Additional Information On How We Handle Your Data</li>
        <li>Making It Easier To Use</li>
      </ul>
      <br />

      <Typography component="h6" variant="h6" color="primary">
        Information We Collect
      </Typography>
      <p>Bloc Notes does not collect any information from you</p>

      <Typography component="h6" variant="h6" color="primary">
        Information You Provide
      </Typography>
      <p>
        <b>• Your Account Information.</b> You do not need to provide any
        information to use Bloc Notes
      </p>

      <Typography component="h6" variant="h6" color="primary">
        Use of Informations
      </Typography>

      <p>
        Since we do not collect any information from you, we also do not use
        them.
      </p>

      <Typography component="h6" variant="h6" color="primary">
        Information You And We Share
      </Typography>
      <p>
        No information is shared between you and us. Bloc Note is totaly free
        and open for use. not information is needed from you to use the
        application.
      </p>

      <Typography component="h6" variant="h6" color="primary">
        Updates To Our Policy
      </Typography>
      <p>
        We may amend or update our Privacy Policy. We will provide you notice of
        amendments to this Privacy Policy mainly by notification via the app, as
        appropriate, and update the “Last modified” date at the bottom of this
        Privacy Policy. Please review our Privacy Policy from time to time.
      </p>

      <p>last modified : Dec 14, 2024</p>
    </Box>
  );
}
